/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface DeleteNote$Params {
  noteId: string;
  entityId: string;
  entityClass: 'Form' | 'FormQualitySection';
}

export function deleteNote(
  http: HttpClient,
  rootUrl: string,
  params: DeleteNote$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteNote.PATH, 'delete');
  if (params) {
    rb.path('noteId', params.noteId, {});
    rb.path('entityId', params.entityId, {});
    rb.path('entityClass', params.entityClass, {});
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteNote.PATH = '/notes/{entityClass}/{entityId}/{noteId}';
